module.exports = __webpack_public_path__ + "fonts/Mukta-500-latin12.b522c8d.woff2";